import { Negotiation } from '@/redux/types/negotiationWebsocket'

export type TabSection = 'channels' | 'negotiations'

export type TabKind =
  | 'advisor'
  | 'decision'
  | 'summary'
  | 'charterPrep'
  | 'charterGroup'
  | 'teamRoom'
  | 'aiPlayer'
  | 'publicRoom'
  | 'conference'
  | 'group'

/** Channel-section kinds that are never grouped under "Negotiations". */
type ChannelOnlyKind =
  | 'advisor'
  | 'decision'
  | 'summary'
  | 'charterPrep'
  | 'charterGroup'

export type AvatarDescriptor = {
  src?: string
  fallback: string
}

export interface SidebarTab {
  id: string
  label: string
  section: TabSection
  kind: TabKind
  negotiation?: Negotiation
  avatars?: AvatarDescriptor[]
  unreadCount?: number
}

export const NEGOTIATION_GROUP_LABELS: Record<
  Exclude<TabKind, ChannelOnlyKind>,
  string
> = {
  teamRoom: 'Team Room',
  aiPlayer: 'AI Player',
  publicRoom: 'Public Room',
  conference: 'Conferences',
  group: 'Group Chats',
}

export const NEGOTIATION_GROUP_ORDER: Exclude<TabKind, ChannelOnlyKind>[] = [
  'teamRoom',
  'aiPlayer',
  'publicRoom',
  'conference',
  'group',
]
